import React, { useState, useEffect, useRef, useCallback } from "react";
import { getBannersElite } from "services/bannersElite";
import { saveClickPromoElite } from "services/analitycs-black-friday";
import { stripEliteBannerName } from "constants/eliteSite";
import {
  normalizeBannerEliteForCarousel,
  filterActiveBannersElite,
} from "utils/bannerElite";
import "../styles/BannerBackfriday.css";

function pickImage(previews = {}, width) {
  const w = width || window.innerWidth;
  const order =
    w < 768
      ? ["mobile", "tablet", "pc", "large"]
      : w < 1280
        ? ["tablet", "pc", "large", "mobile"]
        : w < 1920
          ? ["pc", "large", "tablet", "mobile"]
          : ["large", "pc", "tablet", "mobile"];

  for (const k of order) {
    if (previews[k]) return previews[k];
  }
  return "";
}

const BlackFridayBanner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [slide, setSlide] = useState(0);
  const [winWidth, setWinWidth] = useState(window.innerWidth);
  const timerRef = useRef(null);
  const total = banners.length;

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await getBannersElite();
        const sorted = [...data].sort(
          (a, b) => (parseInt(a.order, 10) || 0) - (parseInt(b.order, 10) || 0),
        );
        setBanners(
          filterActiveBannersElite(sorted.map(normalizeBannerEliteForCarousel)),
        );
      } catch (error) {
        console.error("Error fetching Elite banners:", error);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  useEffect(() => {
    const onResize = () => setWinWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const resetTimer = useCallback(() => {
    clearInterval(timerRef.current);
    if (total > 1) {
      timerRef.current = setInterval(
        () => setSlide((c) => (c + 1) % total),
        6000,
      );
    }
  }, [total]);

  useEffect(() => {
    resetTimer();
    return () => clearInterval(timerRef.current);
  }, [resetTimer]);

  const goTo = (i) => {
    setSlide(((i % total) + total) % total);
    resetTimer();
  };

  const trackBannerClick = useCallback(async (banner) => {
    const name = stripEliteBannerName(banner?.form?.name || "Promoción");
    const link = banner?.form?.link || "";
    const promocion = link
      ? `Click en el banner ${name} con el link ${link}`
      : `Click en el banner ${name}`;

    try {
      await saveClickPromoElite({ promocion, tipo: promocion });
    } catch (error) {
      console.error("Error registrando click del banner:", error);
    }
  }, []);

  if (loading || !total) return null;

  const current = banners[slide];

  const sizeClass =
    winWidth < 768
      ? "carrusel--mobile"
      : winWidth < 1280
        ? "carrusel--tablet"
        : winWidth < 1920
          ? "carrusel--pc"
          : "carrusel--large";

  return (
    <div className={`carrusel ${sizeClass}`}>
      <div className="carrusel__spacer" />

      {banners.map((b, i) => {
        const bg = pickImage(b.previews, winWidth);
        return (
          <div
            key={b.id || i}
            className={`carrusel__slide ${i === slide ? "carrusel__slide--active" : ""}`}
            style={{ backgroundImage: bg ? `url(${bg})` : "none" }}
          />
        );
      })}

      <div className="carrusel__overlay" />

      {current.form?.link && (
        <a
          href={current.form.link}
          className="carrusel__link"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={current.form.name || "Ver promoción"}
          onClick={() => trackBannerClick(current)}
        />
      )}

      {total > 1 && (
        <>
          <button
            className="carrusel__btn carrusel__btn--prev"
            onClick={() => goTo(slide - 1)}
          >
            ‹
          </button>
          <button
            className="carrusel__btn carrusel__btn--next"
            onClick={() => goTo(slide + 1)}
          >
            ›
          </button>
        </>
      )}

      <div className="carrusel__dots">
        {banners.map((_, i) => (
          <div
            key={i}
            onClick={() => goTo(i)}
            className={`carrusel__dot ${i === slide ? "carrusel__dot--active" : ""}`}
          />
        ))}
      </div>
    </div>
  );
};

export default BlackFridayBanner;
